import { initContract } from "@ts-rest/core";
import {
	zManualMembershipUpdatePathParams,
	zManualMembershipUpdateRequestBody,
	zManualMembershipUpdateResponse,
} from "../schemas/member.schemas";

const c = initContract();

export const MemberAPI = c.router(
	{
		updateMembership: {
			description: "Manually update membership status and payment",
			method: "PUT",
			path: "/:memberId/membership",
			pathParams: zManualMembershipUpdatePathParams,
			body: zManualMembershipUpdateRequestBody,
			responses: {
				200: zManualMembershipUpdateResponse,
			},
		},
	},
	{
		pathPrefix: "/members"
	},
);
